<template>
    <div v-if="Object.keys(detail).length > 0">
        <my-nav-bar textColor="#222"
                    :fixed="true"
                    :style="style">
            <template v-slot:right>
                <span class="iconfont icon-qita"
                      @click="showFunc = true"></span>
            </template>
        </my-nav-bar>
        <div class="main">
            <div class="title">{{ detail.title }}</div>
            <div class="info-bar">
                <div class="left">
                    <div class="avatar">
                        <!--                        <img :src="avatar"-->
                        <!--                             alt="">-->
                        <van-image :src="detail.user.image"
                                   width="40"
                                   height="40"
                                   lazy-load
                                   round />
                        <div class="gender"
                             v-if="detail.user.gender == 'm'"></div>
                        <div class="gender gender-blue"
                             v-else></div>
                    </div>
                    <div class="info">
                        <div class="name">
                            <span style="white-space: nowrap">{{ detail.user.nickname }}</span>
                            <div class="level"
                                 style="white-space: nowrap">{{ detail.user.level }}</div>
                        </div>
                        <div class="time">{{ detail.create_time }}</div>
                    </div>
                </div>
                <div class="follow"
                     @click="openDownModal">+ 关注</div>
            </div>
            <!-- 视频帖子 -->
            <div class="video-box"
                 v-if="type == 2">
                <!--                <img class='video-pic'-->
                <!--                     :src="videoImg" />-->
                <!--                <div class="play-btn">-->
                <!--                    <span class="iconfont icon-play"></span>-->
                <!--                </div>-->
                <video id="player-container"></video>
            </div>
            <div class="radio-box"
                 v-if="type == 3"
                 @click="playAudio">
                <div class="radio-left">
                    <div :class="{'left-img-box': true, 'playing': play}">
                        <img class='radio-pic'
                             src="@/assets/img/logo.png"
                             mode="scaleToFill" />
                    </div>
                    <span style="font-size: 14px"
                          v-if="!play">点击播放音频</span>
                    <span style="font-size: 14px"
                          v-else>点击停止播放</span>
                </div>
                <div class="radio-right">
                    <span class="iconfont icon-play"
                          v-if="!play"></span>
                    <span class="iconfont icon-pause"
                          v-else></span>
                </div>
                <audio ref="audio"
                       :src="detail.audio[0].audio" />
            </div>
            <div class="content">
                <span class="tag">#{{ detail.topic.title }}#</span>
                {{ detail.content }}
            </div>
            <!-- 图片组 -->
            <div class="pics"
                 v-if="type == 1">
                <img v-for="(item, index) in imgList"
                     :key="item.id"
                     :src="item.image"
                     @click="previewImage(index)" />
            </div>
            <!-- 占位 -->
            <div class="place"></div>
            <!-- 操作栏 -->
            <my-bottom-bar />
        </div>
        <!-- 功能列表 -->
        <action-sheet v-model="showFunc"
                      :actions="funcList"
                      @select="switchFunc"
                      cancel-text="取消"></action-sheet>
    </div>
</template>
<script>
import { ActionSheet, ImagePreview } from "vant";
import { getPostone } from "@/request/api.js";
export default {
    data() {
        return {
            avatar: "",
            funcList: [{ name: "分享" }, { name: "投诉举报" }],
            showFunc: false,
            type: null,
            detail: {},
            imgList: [],
            videoImg: "", //视频封面
            radioImg: "", //音频封面
            id: "", //帖子id
            style: {},
            playerEl: null,
            play: false,
        };
    },
    components: { ActionSheet },
    created() {
        this.style.color = "#222";
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            //测试数据id=25图片 14视频
            getPostone({ id: this.id }).then((res) => {
                if (res.error_code == 0) {
                    this.detail = res.data;
                    console.log(this.detail);
                    this.$bus.$emit("linkDataUpdate", {
                        redirectPath: 17,
                        cid: this.detail.id,
                    });
                     this.$bus.$emit("linkDataUpdateModel", {
                        redirectPath: 17,
                        cid: this.detail.id,
                    });
                    this.globalInitWxShare(this.detail.content, "", "");
                    this.$nextTick(() => {
                        if (this.type == 2) {
                            this.initVideoPlayer();
                        }
                    });
                    this.imgList = res.data.image;
                    this.tit = res.data.topic.title;
                    if (res.data.video.length > 0) {
                        this.videoImg = res.data.video[0].poster;
                    }
                    if (res.data.audio.length > 0) {
                        this.radioImg = res.data.audio[0].poster;
                    }
                }
            });
        },
        initVideoPlayer() {
            let video = this.detail.video[0];
            if (video) {
                this.playerEl = TCPlayer("player-container", {
                    poster: video.poster,
                }); // player-container-id 为播放器容器 ID，必须与 html 中一致
                this.playerEl.src(video.video);
            }
        },
        playAudio() {
            this.play = !this.play;
            if (this.play) {
                this.$refs.audio.play();
            } else {
                this.$refs.audio.pause();
            }
        },
        previewImage(index) {
            // console.log(this.imgList)
            let urls = this.imgList.map((item) => {
                return item.image;
            });
            ImagePreview({
                images: urls,
                startPosition: index,
            });
        },
        switchFunc(e) {
            console.log(e);
        },
    },
};
</script>
<style lang="less">
.main {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 16px;
    color: #222;
    .title {
        font-size: 20px;
        font-weight: bold;
    }
    .info-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 12px 0 16px 0;
        .left {
            display: flex;
            align-items: center;
            .avatar {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 8px;
                position: relative;
            }
            .avatar > img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            .info {
                .name {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    .level {
                        font-size: 9px;
                        padding: 2px 4px;
                        border-radius: 4px;
                        background-color: #ffedef;
                        color: #ff4c67;
                        transform: scale(0.8);
                    }
                }
                .time {
                    font-size: 12px;
                    color: #a7a7a7;
                    margin-top: 2px;
                }
            }
        }
        .follow {
            font-size: 12px;
            color: #fff;
            padding: 6px 11px;
            border-radius: 100px;
            background: linear-gradient(to right, #ff7b9a, #ff1544);
        }
    }
    .content {
        font-size: 18px;
        text-align: justify;
        text-justify: inter-ideograph;
        .tag {
            color: #2e8cff;
        }
    }
    .pics {
        margin-top: 12px;
        width: 100%;
        img {
            width: 100%;
            height: 205px;
            border-radius: 6px;
            margin-bottom: 8px;
            object-fit: cover;
        }
    }
    .video-box {
        position: relative;
        width: 100%;
        height: 193px;
        overflow: hidden;
        border-radius: 6px;
        margin-bottom: 16px;

        .video-pic {
            position: absolute;
            width: 100%;
            height: 193px;
            object-fit: cover;
        }

        .play-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 56px;
            height: 56px;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            background-color: rgba(34, 34, 34, 0.6);
            color: #fff;

            .btn-icon {
                width: 24px;
                height: 24px;
            }
        }
    }
    .radio-box {
        margin-bottom: 16px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f0f0f0;
        border-radius: 100px;
        .iconfont {
            font-size: 10px;
        }
        .radio-left {
            display: flex;
            align-items: center;
            font-size: 14px;
            .left-img-box {
                position: relative;
                flex-shrink: 0;
                margin: 0 8px 0 12px;
                width: 28px;
                height: 28px;
                border-radius: 50%;
                overflow: hidden;
                &.playing:before {
                    content: "";
                    background-image: url("./ic_live.gif");
                    background-size: cover;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 70%;
                    height: 70%;
                    z-index: 100;
                }
                &.playing:after {
                    content: "";
                    background-color: rgba(0, 0, 0, 0.4);
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                .icon {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 36px;
                    height: 36px;
                }
            }
            .left-img-box > img {
                width: 100%;
                height: 100%;
            }
            .left-text {
                max-width: 400px;
                font-size: 14px;
                color: #222222;
            }
        }

        .radio-right {
            margin-right: 14px;
            width: 20px;
            height: 20px;
            background-color: #ff2e67;
            color: #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                font-size: 10px;
                transform: scale(0.8);
            }
        }
    }
}
#player-container {
    width: 100%;
    height: 100%;
}
</style>
